import {
  SCHOOL_CLIENT_LIST,
  ACCOUNT_VERIFICATION,
  FORGOT_PASSWORD,
  LOGIN,
  RESET_PASSWORD,
  My_CASELOAD,
  My_ACHIEVEMENTS,
  CASELOAD_TASK,
  PROFILE,
  PROFILE_SLUG,
  TASK_ONBOARD,
  CHANGE_PASSWORD,
} from "config/paths";

import Login from "./AuthPages/Login/Index";
import Otp from "./AuthPages/Otp/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import ResetPassword from "./AuthPages/resetPassword/Index";
import ActivateAccount from "./AuthPages/ActivateAccount/Index";
import MyCaseload from "./SideTabPages/myCaseload";
import MyAchievements from "./SideTabPages/myAchievements";
import CaseLoadTasks from "pages/SideTabPages/myCaseload/task";
import ProfileInformation from "./SideTabPages/Profile/[slug]";
import Profile from "./SideTabPages/Profile";
import TaskOnboard from "./Onboard";
import UserInformation from "components/shared/ProfileV2/UserInformation";
import ChangePassword from "components/shared/ProfileV2/ChangePassword";


export const routes = [
  { path: LOGIN, component: <Login /> },
  { path: FORGOT_PASSWORD, component: <ForgotPassword /> },
  { path: "/otp", component: <Otp /> },
  { path: RESET_PASSWORD, component: <ResetPassword /> },
  { path: ACCOUNT_VERIFICATION, component: <ActivateAccount /> },
];

export const privateRoutes = [
  { path: My_CASELOAD, component: <MyCaseload /> },
  { path: CASELOAD_TASK, component: <CaseLoadTasks /> },
  { path: My_ACHIEVEMENTS, component: <MyAchievements /> },
  {
    path: PROFILE,
    component: <Profile />
    // component: <UserInformation />
  },
  {
    path: CHANGE_PASSWORD,
    component: <ChangePassword />
  },
  {
    path: PROFILE_SLUG,
    component: <ProfileInformation />
  },
  // { path: TASK_ONBOARD, component: <TaskOnboard /> },
];
